import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Dialog Header Component
 * Container for dialog title and description
 */
export const DialogHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    className={cn(
      "flex flex-col space-y-1.5 text-center sm:text-start",
      className
    )}
    {...props}
  />
);

DialogHeader.displayName = "DialogHeader";
